import { c as _c } from "react/compiler-runtime";
import { AuthRole } from '@newfront-insurance/auth-api';
import type { MenuItem2 as MenuItem } from '@newfront-insurance/core-ui';
import { MenuItemType } from '@newfront-insurance/core-ui';
import { useProvider } from '@newfront-insurance/react-provision';
import { LayoutConfigProvider } from '../../../../config';

/**
 * Render the account menu popover items that is used in the global navigation based on the type
 * of user that is currently logged in. Returns an array of MenuItems that can be used with the Menu component.
 */
export function useAccountMenuItems() {
  const $ = _c(16);
  const {
    authProvider,
    logoutRedirect
  } = useProvider(LayoutConfigProvider);
  const {
    logout,
    userDetails: user
  } = useProvider(authProvider);
  let t0;
  if ($[0] !== user?.scopes) {
    t0 = user?.scopes.includes(AuthRole.PRODUCER);
    $[0] = user?.scopes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isProducer = t0;
  let t1;
  if ($[2] !== logout || $[3] !== logoutRedirect) {
    t1 = function onLogout() {
      return logout(logoutRedirect);
    };
    $[2] = logout;
    $[3] = logoutRedirect;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onLogout = t1;
  let menuItems;
  if ($[5] !== isProducer || $[6] !== onLogout) {
    menuItems = [];
    if (isProducer) {
      let t2;
      let t3;
      let t4;
      let t5;
      let t6;
      let t7;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          type: MenuItemType.TITLE,
          title: "External links"
        };
        t3 = {
          type: MenuItemType.LINK,
          label: "View oracle",
          href: "https://newfront.zendesk.com",
          target: "_blank"
        };
        t4 = {
          type: MenuItemType.LINK,
          label: "View market access",
          href: "https://10ay.online.tableau.com/#/site/newfrontinsurance/views/CarrierRiskAppetiteCatalog/CarrierRiskAppetite?:iid=1",
          target: "_blank"
        };
        t5 = {
          type: MenuItemType.LINK,
          label: "View your commission reports",
          href: "https://app.captivateiq.com/login?next=/",
          target: "_blank"
        };
        t6 = {
          type: MenuItemType.LINK,
          label: "View your book\u2019s key metrics",
          href: "https://10ay.online.tableau.com/#/site/newfrontinsurance/views/ProducerKeyMetrics/KeyMetrics?:iid=1",
          target: "_blank"
        };
        t7 = {
          type: MenuItemType.DIVIDER
        };
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
      } else {
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
      }
      menuItems.push(t2, t3, t4, t5, t6, t7);
    }
    let t2;
    if ($[14] !== onLogout) {
      t2 = {
        type: MenuItemType.LINK,
        label: "Log out",
        onClick: onLogout
      };
      $[14] = onLogout;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    menuItems.push(t2);
    $[5] = isProducer;
    $[6] = onLogout;
    $[7] = menuItems;
  } else {
    menuItems = $[7];
  }
  return menuItems;
}